export default __webpack_public_path__ + "static/media/find-a-horse.dc282ad3.png";